export const MAX_THUMBNAIL_COUNT = 6;
export const IMAGE_TYPES = ['image/jpeg', 'image/png', 'image/pjpeg'];
export const IMAGE_TYPES_ACCEPT = IMAGE_TYPES.join(',');
export const IMAGE_MIN_SIZE = 740;
export const IMAGE_MAX_SIZE = 5000;
export const IMAGE_MAX_VOLUME = 5;
